export const INVALID_CAPTCHA_TOKEN = 'INVALID_CAPTCHA_TOKEN';
export const INVALID_CAPTCHA_TOKEN_MESSAGE = 'INVALID CAPTCHA TOKEN';


// WEBPACK FOOTER //
// ./src/const/captcha_const.js